import { combineReducers } from 'redux';
import { router } from './router';
import { activeGame } from './active-game';
import { settings } from './settings';

export const allReducers = combineReducers({
    router,
    activeGame,
    settings,
});
